import React, { useEffect, useRef, useState } from "react";
import { useImageInputContext } from "../../ImageInputContext";
import Placeholder from "../Placeholder";
import { StyledGallery } from "./styled";

import {makeArrayFromLength} from 'oolib'
import { SingleImageInput } from "../SingleImageInput";
import { GalleryThumbnails } from "./comps/GalleryThumbnails";
import { SliderShell } from "./comps/SliderShell";
import { useSwipe } from "oolib/dist/utils/customHooks/useSwipe"; // todo- move this hook to fe, or update export in oolib

const GallerySlider = () => {
  const { value, noOfImagesUploading, invert } = useImageInputContext();
  const [activeIdx, setActiveIdx] = useState(0);

  useEffect(() => { setActiveIdx(0), [value?.length] }, []); // reset the activeidx with uploading new images(focus on the newly added Images)

  const uploadingPlaceholders = makeArrayFromLength(noOfImagesUploading).map(
    (d) => undefined
  );

  const isTouchDevice = useRef('ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0);

  const { handleDragStart } = useSwipe({
    isTouchDevice,
    onSlide: (direction) => {
      setActiveIdx((prevIdx) =>
        direction === 'right' ? (prevIdx < value.length - 1 ? prevIdx + 1 : 0) : (prevIdx > 0 ? prevIdx - 1 : value.length - 1)
      );
    },
  });

  return (
    <StyledGallery invert={invert}>
      <GalleryThumbnails setActiveIdx={setActiveIdx} activeIdx={activeIdx} />
      {value?.length > 0 ? (
        <SliderShell
          value={[...uploadingPlaceholders, ...value]}
          activeIdx={activeIdx}
          setActiveIdx={setActiveIdx}
          render={(v, idx) => (
            <SingleImageInput
              {...{
                key: v?.publicUrl || idx,
                value: v,
                handleDragStart,
                // key: v?.publicUrl || idx, //cuz this is done inside the SliderShell
              }}
            />
          )}
        />
      ) : (
        <Placeholder />
      )}
    </StyledGallery>
  );
};

export default GallerySlider;
